import { createAction } from 'redux-actions';

export default function createUiAction(type, payloadCreator, metaCreator) {
  if (metaCreator) {
    const wrappedMetaCreator = (...args) => ({
      ...metaCreator(...args),
      uiAction: true,
    });
    return createAction(type, payloadCreator, wrappedMetaCreator);
  }

  return createAction(type, payloadCreator, () => ({ uiAction: true }));
}

export function markUiAction(action) {
  return { ...action, meta: { ...action.meta, uiAction: true } };
}
